import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Button from '../../shared-components/Button/custom-button';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { CloneSurvey, fetchSurveyDetails } from './home-store/home-actions';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dialog } from 'primereact/dialog';
import { fetchCurrentSurveyID, fetchCurrentSurveyName, fetchProjectCode } from "./home-store/home-actions-creators";
import { getSurveyDefinition } from '../Design/design-store/design-actions-creators';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from "primereact/inputtext";
import excelIcon from "../../../Images/excelicon.png";
import * as XLSX from 'xlsx';
import { loadToaster } from '../../shared-components/toaster/toaster-actions-creators';
import axios from 'axios';
import { startSpinner, stopSpinner } from '../../shared-components/custom-spinner/custom-spinner-store/spinner-actions';
import { API_END_POINT } from '../../../config';

const HomeProjectList = () => {
    const [sortBy, setSortBy] = useState('');
    const [sortOrder, setSortOrder] = useState('');
    const history = useHistory();
    const { fetchProjectDetails } = useSelector((state) => state.projectList);
    const dispatch = useDispatch();
    const [showCloneDialog, setShowCloneDialog] = useState(false);
    const [surveyName, setSurveyName] = useState('');
    const [selectedSurveyCode, setSelectedSurveyCode] = useState('');
    const [selectedSurveyName, setSelectedSurveyName] = useState('');
    const [selectedSurveyID, setSelectedSurveyID] = useState('');
    const [surveyNameError, setSurveyNameError] = useState('');
    const { userLoginDetails } = useSelector((state) => state.login);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const itemsPerPage = 10;
    const [first, setFirst] = useState(0);
    const [deleteSurveyDialog, setDeleteSurveyDialog] = useState({ visible: false, surveyId: null });


    // const onPageChange = (event) => {
    //     setFirst(event.first);
    // };
    const handleSearch = (term) => {
        setSearchTerm(term);
        setFirst(0); // Reset pagination to the first page
       
        if (!term) {
            const sortedData = sortData(fetchProjectDetails || []);
            //const paginatedData = sortedData.slice(first, first + itemsPerPage);
            setFilteredData(sortedData);
            return;
        }
        
        const lowercasedTerm = term.toLowerCase();
        const filteredResults = fetchProjectDetails.filter((project) =>
            (project.survey_code?.toLowerCase() || "").includes(lowercasedTerm) ||
            (project.survey_name?.toLowerCase() || "").includes(lowercasedTerm) ||
            (project.start_date || "").includes(lowercasedTerm) ||
            (project.end_date || "").includes(lowercasedTerm) ||
            (project.survey_status_id?.toString().toLowerCase().trim() || "").includes(lowercasedTerm)  ||
            project.budget?.toString().toLowerCase().includes(lowercasedTerm)

        );
      
        setFilteredData(filteredResults);
    };
    const handleDownload = () => {
        if (!filteredData || filteredData.length === 0) {
            //alert("No data to download!");
             dispatch(loadToaster({ type: 'warn', title: '', msg: 'No data to download!' }))
            
            return;
        }
        const exportData = filteredData.map((project) => ({
            "Code": project.survey_code || "",
            "Name": project.survey_name || "",
            "Start Date": project.start_date || "",
            "End Date": project.end_date || "",
            "Status": project.survey_status_id || "",
            "Budget": project.budget || 0
        }));
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Projects");
        XLSX.writeFile(workbook, "Project_List.xlsx");
    };
    useEffect(() => {
        const isAuthenticated = localStorage.getItem('Authentication') !== null;
        if (isAuthenticated && userLoginDetails.user_id != undefined) {
            dispatch(fetchSurveyDetails(userLoginDetails.user_id));
        }
    }, [dispatch, userLoginDetails.user_id]);

    useEffect(() => {
        if (fetchProjectDetails && fetchProjectDetails.length > 0) {
            const sortedData = sortData(fetchProjectDetails);
            setFilteredData(sortedData);
        }
    }, [fetchProjectDetails,sortBy]);
   
    const sortData = (data) => {
        if (!sortBy) return data;
    
        return data.slice().sort((a, b) => {
            const valueA = a[sortBy];
            const valueB = b[sortBy];
    
            if (valueA < valueB) return sortOrder === 'asc' ? -1 : 1;
            if (valueA > valueB) return sortOrder === 'asc' ? 1 : -1;
            return 0;
        });
    };
    
    const getStatusColor = (survey_status_id) => {
        if (survey_status_id === 'Initiated') {
            return 'bg-warning';
        } else if (survey_status_id === 'InProgress') {
            return 'bg-success';
        } else if (survey_status_id === 'Completed') {
            return 'bg-primary';
        }
        return '';
    };

    const handleEdit = (itemId) => {
        // Navigate to the design route with the item ID
        // history.push(`/design/${itemId}`);
        const selectedSurvey = fetchProjectDetails.find(item => item.survey_id === itemId);
        if (selectedSurvey) {
            dispatch(fetchCurrentSurveyID(selectedSurvey.survey_id));
            dispatch(fetchCurrentSurveyName(selectedSurvey.survey_name));
            dispatch(fetchProjectCode(selectedSurvey.survey_code));
        }
        dispatch(getSurveyDefinition({}));
        const routePath = `/surveys/edit-survey/${selectedSurvey.survey_id}/design`;
        history.push(routePath);

    };
    const createSurvey = () => {
        dispatch(fetchCurrentSurveyID(null));
        dispatch(fetchCurrentSurveyName(null));
        dispatch(fetchProjectCode(null));
        dispatch(getSurveyDefinition({}));
        history.push(`/surveys/create-survey`);

    };
    const hideDialog = () => {
        setShowCloneDialog(false);
        setSurveyName('');
        setSurveyNameError('');
    }
    const clone = () => {
        if (surveyName.trim() === '') {
            setSurveyNameError('Please enter a new survey name');
            return;
        }
        let postObject = {
            source_survey_id: selectedSurveyID,
            survey_name: surveyName,
            created_by: userLoginDetails.user_id
        }
        dispatch(CloneSurvey(postObject));
        hideDialog();

    };
    const renderFooter = () => {
        return (
            <div>
                <Button name='yes' label="Clone" icon="pi pi-check" onClick={clone} />
                <Button name='no' label="Cancel" icon="pi pi-times" onClick={hideDialog} className="p-button-secondary" />
            </div>
        );
    }
    const nameChange = (e) => {
        setSurveyName(e.target.value);
    }
    const handleClone = (itemId) => {
        const selectedSurvey = fetchProjectDetails.find(item => item.survey_id === itemId);
        if (selectedSurvey) {
            setSelectedSurveyCode(selectedSurvey.survey_code);
            setSelectedSurveyName(selectedSurvey.survey_name);
            setSelectedSurveyID(selectedSurvey.survey_id)
        }
        setShowCloneDialog(true);
    };
    const promptDeleteSurvey = (surveyId) => {
    setDeleteSurveyDialog({ visible: true, surveyId });
};

    const confirmDeleteSurvey  = async () => {
        const { surveyId } = deleteSurveyDialog;
    if (!surveyId) return;
    try {
        dispatch(startSpinner());
        const response = await axios.get(`${API_END_POINT.BASE_URL}/api/Survey/DeleteSurvey?survey_id=${surveyId}`);
        
        if (response.status === 200) {
             dispatch(loadToaster({ type: 'success', title: 'Survey deleted successfully!', msg: '' }));
            dispatch(fetchSurveyDetails(userLoginDetails.user_id));
             // optionally refresh list or remove item from local state
        } else {
              dispatch(loadToaster({ type: 'error', title: 'Failed to delete survey.', msg: '' }));
        }
    } catch (error) {
         dispatch(loadToaster({ type: 'error', title: 'Failed to delete survey.', msg: '' }));
    } finally {
        dispatch(stopSpinner());
        setDeleteSurveyDialog({ visible: false, surveyId: null });
    }
};
const cancelDeleteSurvey = () => {
    setDeleteSurveyDialog({ visible: false, surveyId: null });
};
    function handleSurveyCodeClick(item) {
        dispatch(fetchCurrentSurveyID(item.survey_id));
        dispatch(fetchCurrentSurveyName(item.survey_name));
        dispatch(fetchProjectCode(item.survey_code));
        const routePath = `/surveys/edit-survey/${item.survey_id}/dashboard`;
        history.push(routePath);
    }
    return (
        <div className='row mt-4'>
            <div className='col-1'></div>
            <div className='col-10'
                style={{
                    border: '1px solid #d3caca',
                    borderRadius: '10px',
                    backgroundColor: 'white',
                    color: 'black',
                    margin: '7px',
                }}
            >
                <div className="d-flex justify-content-between py-3">
                    <div className="col-md-auto">
                        <div className="row align-items-center" style={{ fontWeight: 'bold', margin: 0 }}>
                            <div className="col-md-auto">
                                <span style={{ fontWeight: 'bold', fontSize: '25px' }}>Projects</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-auto" style={{ textAlign: 'right' }}>
                        <Button
                            name="Save"
                            label="New Project"
                            className="p-button-dark-blue"
                            style={{ backgroundColor: '#1F3BB3', fontSize: '12px', padding: '5px 4px' }}
                            icon="pi pi-plus"
                            onClick={createSurvey}
                        />
                    </div>
                </div>

                <div
                    className="mb-2 mt-1"
                    style={{
                        backgroundColor: 'black',
                        height: 1,
                    }}
                ></div>
                <div className="d-flex justify-content-between py-3">
                    <div className="col-md-auto">
                        <div className="row align-items-center" style={{ fontWeight: 'bold', margin: 0 }}>
                            <div className="col-md-auto">
                                <span className="p-input-icon-left w-100">
                                    <i className="pi pi-search" />
                                    <InputText
                                        type="text"
                                        className="w-100"
                                        placeholder="Search projects..."

                                        onChange={(e) => handleSearch(e.target.value)}
                                    />
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-auto" style={{ textAlign: 'right' }}>
                    <img 
                src={excelIcon} 
                alt="Download Excel" 
                style={{ width: '50px', height: '50px', cursor: 'pointer' }} 
                onClick={handleDownload} 
            />
                    </div>
                </div>
                <div className="container">
                <DataTable
                    value={filteredData}
                    paginator
                    rows={5}
                    rowsPerPageOptions={[5, 10, 20,50]}
                    scrollable
                    size="normal"
                    style={{ width: '100%' }} 
                    emptyMessage={
                    <div style={{ textAlign: 'center', width: '100%', padding: '1px' }}>
                    It looks like there are no projects yet. Start by creating a new one.
                    </div>
                    }
                >
                    <Column field="survey_code" header="Code" sortable
                        body={(rowData) => (
                            <span
                                style={{ textDecoration: "underline", color: "#00BFFF", cursor: "pointer" }}
                                onClick={() => handleSurveyCodeClick(rowData)}
                            >
                                {rowData.survey_code}
                            </span>
                        )}
                        style={{ minWidth: "100px" }} // ✅ Avoid tight columns
                    />
                    <Column field="survey_name" header="Name" sortable style={{ minWidth: "290px" }} />
                    <Column field="start_date" header="Start Date" sortable style={{ minWidth: "120px" }} />
                    <Column field="end_date" header="End Date" sortable style={{ minWidth: "120px" }} />
                    <Column field="budget" header="Completed" sortable style={{ minWidth: "100px" }} />
                    <Column field="survey_status_id" header="Status" sortable
                        body={(rowData) => (
                            <span
                                style={{
                                    display: "inline-block",
                                    padding: "5px 10px",
                                    borderRadius: "12px",
                                    color: "white",
                                    textAlign: "center",
                                    minWidth: "100px",
                                }}
                                className={getStatusColor(rowData.survey_status_id)}
                            >
                                {rowData.survey_status_id}
                            </span>
                        )}
                        style={{ minWidth: "150px" }}
                    />
                    <Column header="Actions" style={{ minWidth: "150px", textAlign: "center" }}
                        body={(rowData) => (
                            <div style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "5px",
                                flexWrap: "nowrap"
                            }}>
                                <Button
                                    icon="pi pi-pencil"
                                    className="p-button-primary p-button-xs"
                                    style={{ width: "30px", height: "30px", padding: "5px", fontSize: "12px" }}
                                    onClick={() => handleEdit(rowData.survey_id)}
                                />
                                <Button
                                    icon="pi pi-trash"
                                    className="p-button-danger p-button-xs"
                                    style={{ width: "30px", height: "30px", padding: "5px", fontSize: "12px" }}
                                    onClick={() => promptDeleteSurvey(rowData.survey_id)}
                                />
                                <Button
                                    icon="pi pi-copy"
                                    className="p-button-warning p-button-xs m-0"
                                    style={{ width: "30px", height: "30px", padding: "5px", fontSize: "12px" }}
                                    onClick={() => handleClone(rowData.survey_id)}
                                />
                            </div>
                        )}
                    />
                </DataTable>



                    <Dialog
                        header="Clone Project"
                        visible={showCloneDialog}
                        style={{ width: '45vw', overflow: 'none' }}
                        contentStyle={{ height: '150px' }}
                        onHide={hideDialog}
                        maximizable={false}
                        footer={renderFooter()}
                        className="clone-project" // Add the custom class to the Dialog component
                    >
                        <div className="clone-project">
                            <div className="row mt-3">
                                <div className="col-5">
                                    <div>
                                        <span
                                            // className="text-view-label"
                                            style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: '3px' }}
                                        >
                                            Selected Project:
                                        </span>
                                    </div>
                                    <b style={{ color: '#1F3BB3', fontSize: 14, marginTop: '2px' }}>
                                        {selectedSurveyCode} - {selectedSurveyName}
                                    </b>
                                </div>
                                <div className="col-7">
                                    <div>
                                        <span
                                            // className="text-view-label"
                                            style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: '3px' }}
                                        >
                                            New Survey Name
                                            <span style={{ fontWeight: 600, color: '#b21dac', paddingLeft: 3 }}>*</span>:
                                        </span>
                                    </div>
                                    <InputTextarea
                                        style={{ fontSize: 'normal', width: '100%' }}
                                        name="title"
                                        placeholder="Enter New Survey Name"
                                        rows={1}
                                        onChange={nameChange}
                                        value={surveyName}
                                        autoResize={true}
                                    />
                                    {surveyNameError && <span className="error-message">{surveyNameError}</span>}
                                </div>
                            </div>
                        </div>
                    </Dialog>


                </div>
                {/* <Paginator
                    first={first}
                    rows={itemsPerPage}
                    totalRecords={paginatedData.length}
                    onPageChange={onPageChange}
                    className="p-mt-3 p-mb-0"
                /> */}
                  <Dialog
                                header="Confirmation Required"
                                visible={deleteSurveyDialog.visible}
                                style={{ width: '40vw' }}
                                onHide={cancelDeleteSurvey}
                                footer={
                                        <>
                                            <Button label="Yes" icon="pi pi-check" className="p-button-danger"  style={{ fontSize: '12px', padding: '6px 6px' }} onClick={confirmDeleteSurvey} />
                                            <Button label="No" icon="pi pi-times"   className="p-button-secondary"  style={{ fontSize: '12px', padding: '6px 6px' }} onClick={cancelDeleteSurvey} />
                                        </>
                                }           
                                contentStyle={{ height: '70px' }}
                            >
                
                                <div className="container">
                                    <p className="text-start">
                                        {/* You cannot undo this action. <b>Are you sure you want to proceed?</b> */}
                                        Are you sure you want to delete this survey? This action cannot be undone.
                                    </p>
                                   
                                </div>
                            </Dialog>
            </div>

            <div className='col-1'></div>

        </div>
    );
};

export default HomeProjectList;
